import classNames from 'classnames';
import { type ReactNode, type SVGProps, useRef } from 'react';
import { useHoverDirty } from 'react-use';

type IconScheme = 'dark' | 'light';

interface ChildrenProps {
  color: string;
}

interface Props extends SVGProps<SVGSVGElement> {
  active?: boolean;
  scheme?: IconScheme;
  color?: string;
  size?: number;
  children: (props: ChildrenProps) => ReactNode;
}

const colors: Record<IconScheme, string[]> = {
  dark: ['#909090', '#fff'],
  light: ['#909090', '#1a1a1a'],
};

const getColor = (params: {
  active?: boolean;
  scheme: IconScheme;
  color?: string;
  isHovered: boolean;
}) => {
  const { active, isHovered, scheme, color } = params;
  if (color) return color;
  const arr = colors[scheme];
  if (active !== undefined) {
    return active ? arr[1] : arr[0];
  }
  return isHovered ? arr[1] : arr[0];
};

function SvgIcon({
  active,
  scheme = 'dark',
  className,
  children,
  color,
  size = 16,
  ...rest
}: Props) {
  const cx = classNames('cursor-pointer select-none', className);
  const ref = useRef(null);
  const isHovered = useHoverDirty(ref);
  const iconColor = getColor({ active, isHovered, scheme, color });
  return (
    <svg
      width={size}
      height={size}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={cx}
      {...rest}
      ref={ref}
    >
      {children({ color: iconColor })}
    </svg>
  );
}

export default SvgIcon;
